import { config } from '@ingka/webc-tools';
// This pattern will find each 'skapa-' that are not preceeded by "-" (to ignore css variables) and not preceeded by "[" (to ignore attribute names).
const pattern = /(?:([^-\[\.])|^)skapa-/g;
export function prefixReplacer(rawHTML) {
    return rawHTML.replace(pattern, `$1${config.prefix}-`);
}
